import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";

const EmbedCampaignSettings = (props) => {
  const [contextData] = useContext(VariantContextData);
  const website = contextData.objects.website;
  const cta = contextData.objects.cta;
  const object = props.object;
  const object_type = props.object_type;
  const object_id = props.object_id;

  const getCtaOptions = () => {
    if (!website || !website.ctas) return [];

    return Object.values(website.ctas)
      .filter(
        (campaign) =>
          campaign.cta_type === "inline" &&
          campaign.archived !== true &&
          campaign.id !== cta.id
      )
      .map((campaign) => ({
        value: campaign.id.toString(),
        text: `${campaign.name || `Campaign ${campaign.id}`} (${campaign.id})`,
      }));
  };

  return (
    <VariantBuilderSetting
      object={object}
      label="Select Embed Campaign"
      setting_name={"[options][embed-cta-id]"}
      setting_type="select"
      object_type={object_type}
      object_id={object_id}
      value={
        object.options["embed-cta-id"]
          ? object.options["embed-cta-id"].toString()
          : ""
      }
      options={getCtaOptions()}
      placeholder="Select a campaign to embed"
      allow_empty={true}
      warning={
        !object.options["embed-cta-id"]
          ? "Campaign selection is required"
          : undefined
      }
    />
  );
};

export default EmbedCampaignSettings;
